import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles<{ color: string | undefined }>()(
  (theme, { color }) => ({
    tag: {
      ...dFlex(),
      height: 24,
      background: `${color}`,
      padding: '4px 6px',
      borderRadius: theme.borderRadius.sm,
    },
  }),
);

export default useStyles;
